(function () {
    'use strict';

    var module = angular.module('uwAgenda.users');
    module.controller('UserWebsiteController', ['$uibModal', '$state', 'UserWebsiteService', 'SharedAgendaService', 'Alert', 'Website', 'website', UserWebsiteControllerFn]);

    // controller for edit-user-website directive
    function UserWebsiteControllerFn($uibModal, $state, UserWebsiteService, SharedAgendaService, Alert, Website, website) {
        /* jshint validthis:true */
        var vm = this;

        // website
        vm.website = null;

        activate();

        // activation work
        function activate() {
            // new object
            vm.website = new Website();
            vm.website.extend(website);
        } // activate       

        // remove website
        vm.remove = function () {
            if (vm.website === null || !vm.website.id) { return; }

            // ask to remove
            askToRemoveWebsite().then(function (result) {
                // user clicked ok
                if (result) {
                    UserWebsiteService.removeWebSite(vm.website.id).then(function (response) {
                        // delete
                        vm.website = new Website();
                        Alert.success(response);
                    });
                } // if                
            });
        };

        // install website
        vm.install = function () {
            if (vm.website !== null && vm.website.id > 0) { return; }

            // prepare for save
            vm.website.prepareForSave();

            // setup
            UserWebsiteService.installWebSite(vm.website).then(function (result) {
                Alert.success("Website Installed");
                $state.go($state.current, {}, { reload: true });
            });
        };

        /* ask user to remove domain */
        function askToRemoveWebsite() {
            //// show modal
            return $uibModal.open({
                keyboard: false,
                animation: true,
                templateUrl: '/app/users/templates/user-website-remove-question.template.html',
                controller: 'UserWebsiteRemoveQuestionController',
                controllerAs: 'vm',
                size: 'xs'
            }).result;
        }

    }
})();
